import React, { useEffect } from "react";
import "./BlogsHero.css";
import heroVideo from "../../assets/videos/blog.mp4";

const BlogsHero = () => {
  useEffect(() => {
    const hero = document.querySelector(".blogs-hero-content");

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            hero.classList.add("show-content");
          }
        });
      },
      { threshold: 0.3 }
    );

    observer.observe(hero);
  }, []);

  return (
    <section className="blogs-hero">
      
      {/* Background Video */}
      <video className="blogs-hero-video" autoPlay loop muted playsInline>
        <source src={heroVideo} type="video/mp4" />
      </video>

      <div className="blogs-hero-overlay"></div>

      <div className="blogs-hero-content">
        <h1>BLOGS & NEWS</h1>
        <p>Empower Your Business, Embrace IT Excellence!</p>

        <button className="blogs-btn">Explore Blogs</button>
      </div>
    </section>
  );
};

export default BlogsHero;
